import * as loadingState from '@dragonfruit/constants/loadingState';
export const SEND_CONFIRMATION_EMAIL = 'SEND_CONFIRMATION_EMAIL';
export const RESEND_EMAIL = 'RESEND_EMAIL';
export const SEND_CONFIRMATION_EMAIL_SUCCESS =
  'SEND_CONFIRMATION_EMAIL_SUCCESS';
export const SEND_CONFIRMATION_EMAIL_ERROR = 'SEND_CONFIRMATION_EMAIL_ERROR';

export const sendConfirmationEmail = userId => ({
  type: SEND_CONFIRMATION_EMAIL,
  payload: {
    userId,
  },
});

export const resendEmail = () => ({
  type: RESEND_EMAIL,
});

export const sendConfirmationEmailSuccess = () => ({
  type: SEND_CONFIRMATION_EMAIL_SUCCESS,
});

export const sendConfirmationEmailError = () => ({
  type: SEND_CONFIRMATION_EMAIL_ERROR,
});

const INIT_STATE = {
  sendEmailStatus: loadingState.EMPTY,
  lastSentTime: null,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SEND_CONFIRMATION_EMAIL:
      return {
        ...state,
        sendEmailStatus: loadingState.LOADING,
      };
    case SEND_CONFIRMATION_EMAIL_SUCCESS:
      return {
        ...state,
        sendEmailStatus: loadingState.READY,
        lastSentTime: Date.now() / 1000,
      };
    case SEND_CONFIRMATION_EMAIL_ERROR:
      return {
        ...state,
        sendEmailStatus: loadingState.ERROR,
      };
    default:
      return state;
  }
};

export default reducer;

export const getLastMessageTime = state => state.sendEmail.lastSentTime;



// WEBPACK FOOTER //
// ./app/redux/sendEmail.js